import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Paper, Tooltip, Typography } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import UnoButton from "../../utils/UnoButton";
import { unoTheme } from "../../../assets/styles/unoTheme";
import MySwitch from '../../utils/MySwitch';

import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';

//Redux
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

//API
import { UserAPI } from "../../../API/user";

//MyInputs
import MyTextField from "../../utils/MyTextField";

import CircularProgress from '@material-ui/core/CircularProgress';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import _ from 'lodash';

import MyDatePicker from '../../utils/MyDatePicker'

import { isValidEmail, isValidCpf, justNumbers, applyMaskPhone, getConsultingId, isValidCnpj } from "../../utils/utils";

import ConfirmActionRightContent from './ConfirmActionRightContent'
import MySelect from "../../utils/MySelect";
import { AccreditationProcessAPI } from "../../../API/accreditationProcess";
import { XmlAssetAPI } from "../../../API/xmlAsset";
import MyDivider from "../../utils/MyDivider";
import { ClientAPI } from "../../../API/client";
import MyAutoComplete from "../../utils/MyAutoComplete";
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles((theme) => ({
    root: {
        //height: '100vh',
        width: '100%',
    },

    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(5)
    },

    main: {
        height: 'calc(100% - 128px)',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        textAlign: 'left',
        overflowY: 'scroll',

        '& .MuiPaper-root': {
            height: 'calc(100% - 184px)',
        }
    },

    labelCellTop: {
        fontSize: '13px',
        fontWeight: '600'
    },
    labelCellBottom: {
        fontSize: '13px',
        fontColor: unoTheme.defaultTextColor
    },

    bottom: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        justifyContent: 'flex-end',

        '& .bottomButtons': {
            paddingTop: theme.spacing(2),
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }

    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    table: {
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px',
            },
        },
    },

    detailRow: {
        cursor: "pointer",
        '& > *': {
            borderBottom: 'unset',
            padding: '3px 16px 3px 16px !important',
            textTransform: 'uppercase',
            color: unoTheme.defaultTextColor,
            fontWeight: 400,
            fontSize: '12px',
        },
        '&:nth-of-type(odd)': {
            backgroundColor: unoTheme.secondaryTuplaTable,
        },

    },

    flexCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
        height: '100%',
        paddingLeft: '0px !important',

        '& .MuiTypography-root': {
            fontWeight: 400,
            fontSize: '12px',
        },
    },
    statusOff: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusOk: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusPendent: {
        color: unoTheme.warningColor,
        fill: unoTheme.warningColor,
    },
    marginLeft: {
        marginLeft: '5px',
    },
    leftHeader: {

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    labelYear: {
        fontSize: '36px',
        paddingRight: theme.spacing(2),
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },

    disableMonth: {
        position: 'absolute',
        height: '100%',
        width: '100%',
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: unoTheme.errorColor,
    },
    warning: {
        color: unoTheme.warningColor
    },
    hiddenIcon: {
        visibility: 'hidden',
    },
    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },
    validationMessage: {
        color: unoTheme.errorColor,
        fontSize: '14px',
        textAlign: 'right',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    selectable: {
        '& input': {

            cursor: 'pointer',
            color: unoTheme.mainColor,
        }
    }
}));

/**
 * Mantém IDs estáveis pra usar como key, sem alterar alinhamento/layout.
 */
function ensureRowId(row) {
    if (row && row._id) return row;
    return { ...row, _id: `${Date.now()}-${Math.random()}` };
}

/**
 * ✅ IMPORTANTE: componente fora do NewXmlAsset para não ser recriado a cada render.
 * Não altera alinhamento (mantive o mesmo Grid e estilos).
 */
function InputClientWithCod(props) {
    const {
        row,
        index,
        isSubmitted,
        allClients,
        onChangeClient,
        onChangeCod,
        onRemove,
    } = props;

    return (
        <Grid container spacing={2}>
            <Grid item lg={6} md={6} sm={6}>
                {allClients ? (
                    <MyAutoComplete
                        id={'client-with-cod-' + index}
                        options={allClients}
                        autoComplete
                        customPadding={'6px 16px'}
                        customHeight={'25px'}
                        value={row.client}
                        onChange={(event, newValue) => onChangeClient(newValue, index)}
                        outerlabel={'Selecione o cliente'}
                        placeholder={"Selecione o cliente"}
                        getOptionLabel={(option) => option.label_name}
                        getOptionSelected={(option, value) => option.id === value.id}
                        renderOption={(option) => (
                            <React.Fragment key={'autocomplete-' + option.id}>
                                <span>{option.label_name}</span>
                            </React.Fragment>
                        )}
                    />
                ) : null}
            </Grid>

            <Grid item lg={5} md={5} sm={5}>
                <MyTextField
                    id={'cod-client-with-cod-' + index}
                    value={row.cod || ''}
                    onChange={(value) => onChangeCod(value, index)}
                    align="right"
                    outerlabel={'Código Audesp'}
                    placeholder="Ex: 43423534"
                    validator={(row.cod || '') === "" && isSubmitted ? true : undefined}
                    helperText={"Insira o valor do código Audesp"}
                    type="text"
                    fullWidth />
            </Grid>

            <Grid item lg={1} md={1} sm={1}>
                <UnoButton
                    style={{ marginTop: '22px', marginLeft: '0px' }}
                    isIconButton
                    onClick={() => onRemove(index)}
                    size='small'
                    myIcon={<DeleteIcon />}
                    type={'default'}>
                    Remover
                </UnoButton>
            </Grid>
        </Grid>
    );
}

export default function NewXmlAsset(props) {

    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();

    const currentUser = useSelector(state => state.currentUser)
    const clientOn = useSelector(state => state.clientOn)

    const dispatch = useDispatch();

    const { content } = props

    const [openBackdrop, setOpenBackdrop] = useState(false);

    const [confirmingAction, setConfirmingAction] = useState(false);

    //form
    const [submitted, setSubmitted] = useState(false);

    const [name, setName] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [clientsWithAudespCod, setClientsWithAudespCod] = useState("");

    const [allClients, setAllClients] = useState(null);
    async function loadAllClients() {
        setOpenBackdrop(true);

        const responseAllClients = await ClientAPI.listAllClients();
        if (responseAllClients.success) {
            setAllClients(responseAllClients.body.rows.map(el => ({
                id: el.id,
                label_name: el.label_name
            })));
            setOpenBackdrop(false);
            return responseAllClients.body.rows;
        } else {
            setOpenBackdrop(false);
            return [];
        }
    }

    async function doSave(event) {
        event.preventDefault();
        setSubmitted(true);

        // ====== validações do formulário ======
        const items = (multipleInputsClientWithCod?.items || []);

        // 1) valida campos básicos
        if (!name || !isValidCnpj(cnpj)) {
            return;
        }

        // 2) valida preenchimento de client e cod em todos os itens (se existir itens)
        const invalidIndexes = [];
        items.forEach((item, idx) => {
            const hasClient = !!item?.client?.id; // ajuste se seu client tiver outro identificador
            const cod = (item?.cod ?? '').toString().trim();
            const hasCod = cod.length > 0;

            if (!hasClient || !hasCod) invalidIndexes.push(idx);
        });

        if (invalidIndexes.length > 0) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: `Preencha Cliente e Código Audesp em todas as linhas. Linhas com problema: ${invalidIndexes.map(i => i + 1).join(', ')}.`
            }));
            return;
        }

        // 3) valida duplicidade de client
        // pega só os ids (ou use outro campo único, se não for id)
        const clientIds = items.map(i => i.client.id);
        const duplicates = clientIds.filter((id, idx) => clientIds.indexOf(id) !== idx);
        const uniqueDuplicates = Array.from(new Set(duplicates));

        if (uniqueDuplicates.length > 0) {
            // opcional: montar nomes dos clientes duplicados para ficar mais amigável
            const duplicatedNames = items
                .filter(i => uniqueDuplicates.includes(i.client.id))
                .map(i => i.client.label_name || i.client.name || i.client.id);

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: `Existe cliente repetido em mais de uma linha. Remova as duplicidades: ${Array.from(new Set(duplicatedNames)).join(', ')}.`
            }));
            return;
        }

        // ====== salvamento ======
        setOpenBackdrop(true);

        const xmlAsset = {
            id: content.update ? content.data.id : null,
            name,
            cnpj,
            clients_with_audesp_cod: JSON.stringify(
                items.map(({ _id, ...rest }) => rest)
            ),
        };

        const response = await XmlAssetAPI.save(xmlAsset);

        if (response.success) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: `Ativo XML ${content.update ? 'atualizado' : 'cadastrado'} com sucesso`
            }));
            dispatch(allActions.rightContentActions.update());
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: `Erro ao ${content.update ? 'atualizar' : 'cadastrar'} o ativo XML: ` + response.body.message
            }));
        }

        setOpenBackdrop(false);
    }


    function initForm(xmlAsset) {

        setName(xmlAsset.name || "");
        setCnpj(xmlAsset.cnpj || "");

        // aqui você preenchia clientsWithAudespCod, mas o UI agora usa multipleInputsClientWithCod.items
        // vou manter o setClientsWithAudespCod como estava (caso use em outro lugar)
        if (xmlAsset.clients_with_audesp_cod) {
            try {
                const parsed = JSON.parse(xmlAsset.clients_with_audesp_cod);
                setClientsWithAudespCod(parsed);

                // popula os inputs mantendo o layout e adicionando _id estável
                const parsedRows = Array.isArray(parsed) ? parsed : [];
                setMultipleInputsClientWithCod(prev => ({
                    ...prev,
                    items: parsedRows.map(r => ensureRowId({
                        client: r.client ?? null,
                        cod: r.cod ?? '',
                    }))
                }));
            } catch (e) {
                setClientsWithAudespCod([]);
                setMultipleInputsClientWithCod(prev => ({ ...prev, items: [] }));
            }
        } else {
            setClientsWithAudespCod([]);
            setMultipleInputsClientWithCod(prev => ({ ...prev, items: [] }));
        }
    }

    async function doDelete() {

        setOpenBackdrop(true)

        const response = await XmlAssetAPI.delete(content.data.id);

        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: 'Ativo XML excluído com sucesso!'
            }))

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: `Erro ao excluir ativo XML: ` + response.body.message
            }))
        }

        setOpenBackdrop(false)
        dispatch(allActions.rightContentActions.update());

    }

    function handleCancel() {
        setConfirmingAction(false);
    }

    function handleConfirm() {
        doDelete();
    }

    const [multipleInputsClientWithCod, setMultipleInputsClientWithCod] = useState({
        focusOnId: '',
        items: []
    });

    const getDefaultClientWithCodShape = () => ensureRowId({
        client: null,
        cod: '',
    });

    async function addInputClientWithCod() {
        setMultipleInputsClientWithCod(prev => ({
            ...prev,
            items: [...(prev.items || []), getDefaultClientWithCodShape()],
            // opcional: não forço foco aqui; mantém seu comportamento original sem “puxar” foco indevido
            focusOnId: prev.focusOnId,
        }));
    }

    function changeInputClientWithCod(attr, newValue, index) {
        setMultipleInputsClientWithCod(prev => {
            const items = [...(prev.items || [])];
            if (!items[index]) return prev;

            const updated = { ...items[index], [attr]: newValue };
            items[index] = updated;

            return {
                ...prev,
                items,
                focusOnId: attr + '-' + index
            };
        });
    }

    // useEffect(() => {
    //     // Mantive sua lógica de foco, mas ela só foca quando não é o autocomplete
    //     if (multipleInputsClientWithCod && multipleInputsClientWithCod.items && multipleInputsClientWithCod.items.length > 0) {

    //         const domElement = document.getElementById(multipleInputsClientWithCod.focusOnId);
    //         if (domElement && !multipleInputsClientWithCod.focusOnId.includes('client-with-cod')) {
    //             domElement.focus();
    //         }

    //     }
    // }, [multipleInputsClientWithCod])

    function removeInputClientWithCod(indexToRemove) {
        setMultipleInputsClientWithCod(prev => {
            const items = (prev.items || []).filter((_, i) => i !== indexToRemove);
            return { ...prev, items };
        });
    }

    useEffect(() => {
        loadAllClients();
    }, [])

    useEffect(() => {

        if (!allClients) return;
        if (content) {
            if (content && content.update) {
                initForm(content.data);
            }
        }

    }, [allClients]);

    return (
        <div className={classes.root}>

            {
                !confirmingAction ?

                    <>
                        <div className={classes.header}>
                            <IconButton
                                className={!content.update ? classes.hiddenIcon : ""}
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                                <ArrowBackIcon />
                            </IconButton>


                            <div>
                                <Typography
                                    variant={'h6'}
                                    align={'center'}>

                                    {content.update ? "Editar Ativo XML" : "Cadastrar Ativo XML"}

                                </Typography>

                                <Typography
                                    variant={'body1'}
                                    align={'center'}
                                    style={{ color: unoTheme.defaultTextColor }}>

                                    {content?.data?.cnpj ? `CNPJ: ${content.data.cnpj}` : ''}

                                </Typography>

                            </div>


                            <IconButton className={content.update ? classes.hiddenIcon : ""}
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                                <CloseIcon />
                            </IconButton>

                        </div>


                        <div className={classes.main}>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <MyTextField required
                                        outerlabel="Nome do ativo"
                                        size={'small'}
                                        validator={name == "" && submitted ? true : undefined}
                                        variant="outlined"
                                        onChange={(value) => setName(value)}
                                        helperText={"Insira o nome do ativo"}
                                        placeholder={'Insira o nome do ativo'}
                                        value={name} />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <MyTextField
                                        value={cnpj}
                                        onChange={(value) => setCnpj(value)}
                                        size={'small'}
                                        variant="outlined"
                                        validator={!isValidCnpj(cnpj) && submitted ? true : undefined}
                                        helperText={"Insira um CNPJ válido"}
                                        mask={['cnpj']}
                                        placeholder={'Insira o CNPJ'}
                                        outerlabel="CNPJ" />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>

                                    <div style={{ display: 'flex', alignItems: 'anchor-center', justifyContent: 'space-between', paddingBottom: "24px" }}>

                                        <Typography style={{ margin: "0px", padding: "0px" }}>
                                            Clientes com código Audesp
                                        </Typography>

                                        <UnoButton
                                            style={{ marginTop: '16px', marginRight: '16px' }}
                                            size='verySmall'
                                            type={'warningClean'}
                                            startIcon={<AddIcon />}
                                            onClick={() => addInputClientWithCod()}>{'Adicionar cliente'}
                                        </UnoButton>
                                    </div>

                                </Grid>
                            </Grid>

                            {multipleInputsClientWithCod
                                && multipleInputsClientWithCod.items
                                && multipleInputsClientWithCod.items.map((row, index) => (
                                    <InputClientWithCod
                                        key={row._id || index}
                                        row={row}
                                        index={index}
                                        isSubmitted={submitted}
                                        allClients={allClients}
                                        onChangeClient={(newValue, idx) => changeInputClientWithCod('client', newValue, idx)}
                                        onChangeCod={(newValue, idx) => changeInputClientWithCod('cod', newValue, idx)}
                                        onRemove={(idx) => removeInputClientWithCod(idx)}
                                    />
                                ))}

                            <br />
                            <br />
                            <div className={classes.bottom}>

                                <div className={'bottomButtons'}>

                                    <UnoButton
                                        className={
                                            !content.update ? classes.hiddenIcon : null}
                                        onClick={() => setConfirmingAction(true)}
                                        type='errorClean'>
                                        {"Excluir ativo"}
                                    </UnoButton>

                                    <UnoButton
                                        onClick={(e) => doSave(e)}
                                        type={content.update ? 'success' : 'primary'}>
                                        {content.update ? "Atualizar Ativo" : "Salvar Ativo"}
                                    </UnoButton>
                                </div>

                            </div>

                        </div>
                    </>

                    :

                    <ConfirmActionRightContent
                        message={`Tem certeza que quer excluir 
                        o ativo ${content && content.data ? content.data.name : ''}?`}
                        handleCancel={handleCancel}
                        handleConfirm={handleConfirm}
                    />
            }

            {
                openBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                    </div> : null
            }

        </div >
    );
}
